export enum SettingCategory {
  GeneralSettings = "General Settings",
  PrivacySettings = "Privacy Settings",
  NotificationSettings = "Notification Settings"
}
